import styled from 'styled-components'

export const ProjectName = styled.b`
  word-break: break-all;
`
